import type { InvoiceTableHeader } from '../components/Tables/InvoiceListTable.component';

export const SEGMENT_INVOICE_TABLE_HEADERS: InvoiceTableHeader[] = [
  { key: 'invoiceNumber', label: 'Numéro',    minWidth: 140, align: 'left' },
  { key: 'status',        label: 'Statut',    minWidth: 130, align: 'left' },
  { key: 'format',        label: 'Format',    minWidth: 80,  align: 'left' },
  { key: 'period',        label: 'Période',   minWidth: 220, align: 'left' },
  { key: 'totalHT',       label: 'Total HT',  minWidth: 110, align: 'right' },
  { key: 'totalTTC',      label: 'Total TTC', minWidth: 110, align: 'right' },
  { key: 'createdAt',     label: 'Créée le',  minWidth: 170, align: 'right' },
  { key: 'actions',                            minWidth: 65,  align: 'right' },
];

export const ORGANIZATION_INVOICE_TABLE_HEADERS: InvoiceTableHeader[] = [
  { key: 'invoiceNumber',  label: 'Numéro',              minWidth: 140, align: 'left' },
  { key: 'status',         label: 'Statut',              minWidth: 130, align: 'left' },
  { key: 'format',         label: 'Format',              minWidth: 80,  align: 'left' },
  { key: 'deliveryPoints', label: 'Points de livraison', minWidth: 200, align: 'left' },
  { key: 'period',         label: 'Période',             minWidth: 220, align: 'left' },
  { key: 'totalHT',        label: 'Total HT',            minWidth: 110, align: 'right' },
  { key: 'totalTTC',       label: 'Total TTC',           minWidth: 110, align: 'right' },
  { key: 'createdAt',      label: 'Créée le',            minWidth: 170, align: 'right' },
  { key: 'actions',                                       minWidth: 65,  align: 'right' },
];
